import { watchImmediate } from "@vueuse/core";
import { computed } from "vue";
import { useTheming } from "./settings";

export function withCustomTheme() {
  const theme = useTheming()
  const background_color = computed(() => theme?.value?.background_color ?? '#fff');
  const primary_color = computed(() => theme?.value?.primary_color ?? '#47f');
  const text_color = computed(() => theme?.value?.text_color ?? '#111');

  const prop = document.body.style.setProperty.bind(document.body.style)
  watchImmediate(background_color, (c) => prop("--theme-background", c))
  watchImmediate(primary_color, (c) => prop("--theme-primary", c))
  watchImmediate(primary_color, (c) => prop("--theme-primary-light", _mix(c, "#fff", 0.5)))
  watchImmediate(primary_color, (c) => prop("--theme-primary-dark", _mix(c, "#000", 0.5)))
  watchImmediate(text_color, (c) => prop("--theme-foreground", c))

  // watchImmediate(() => theme.value?.google_font, (fontName) => {
  //   if (fontName) {
  //     document.body.style.fontFamily = fontName + ", Inter, sans-serif";
  //     const fontHref = `https://fonts.googleapis.com/css2?family=${fontName.replace(' ', '+')}&display=swap`
  //     const stylesheet = document.createElement('link');
  //     stylesheet.rel = "stylesheet";
  //     stylesheet.href = fontHref;
  //     document.head.appendChild(stylesheet);
  //   }
  // })
}

function _mix(hex1, hex2, ratio) {
  return `color-mix(in srgb, ${hex1} ${ratio * 100}%, ${hex2})`
}
